// extracted by mini-css-extract-plugin
export default {"header":"header_header__VPyo0","eventName":"header_eventName__aUrZ4"};